import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, BusyIndicator, Title } from "@ui5/webcomponents-react";
import { toast } from "sonner";
import { AdminApi } from "../../api/client";

function Field({ label, children }) {
  return (
    <div className="field-row">
      <label>{label}</label>
      {children}
    </div>
  );
}

export default function BookingsPage() {
  const [filters, setFilters] = useState({ status: "", from: "", to: "" });
  const [data, setData] = useState(null);
  const [exporting, setExporting] = useState(false);

  const params = useCallback(() => {
    const p = {};
    if (filters.status) p.status = filters.status;
    if (filters.from) p.from = filters.from;
    if (filters.to) p.to = filters.to;
    return p;
  }, [filters]);

  const reqId = useRef(0);
  const load = useCallback(() => {
    const id = ++reqId.current;
    setData(null);
    AdminApi.listBookings(params())
      .then((d) => { if (id === reqId.current) setData(d); })
      .catch(() => { if (id === reqId.current) setData({ bookings: [], total: 0 }); });
  }, [params]);

  useEffect(() => { load(); }, [load]);

  const cancel = async (b) => {
    try {
      await AdminApi.cancelBooking(b.id);
      toast.success("Buchung storniert.");
      load();
    } catch { toast.error("Stornierung fehlgeschlagen."); }
  };

  const exportCsv = async () => {
    setExporting(true);
    try {
      await AdminApi.downloadBookingsCsv(params());
    } catch (e) {
      // A 401 triggers the interceptor's redirect to login — don't flash a misleading error.
      if (e.response?.status !== 401) toast.error("Export fehlgeschlagen.");
    } finally {
      setExporting(false);
    }
  };

  return (
    <div>
      <Title level="H2" style={{ margin: "8px 0 16px" }}>Buchungen</Title>

      <div className="toolbar-row">
        <Field label="Status">
          <select className="native-input" value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })}>
            <option value="">Alle</option>
            <option value="pending">Offen</option>
            <option value="confirmed">Bestätigt</option>
            <option value="cancelled">Storniert</option>
          </select>
        </Field>
        <Field label="Von"><input className="native-input" type="date" value={filters.from} onChange={(e) => setFilters({ ...filters, from: e.target.value })} /></Field>
        <Field label="Bis"><input className="native-input" type="date" value={filters.to} onChange={(e) => setFilters({ ...filters, to: e.target.value })} /></Field>
        <Button icon="refresh" onClick={load}>Filtern</Button>
        <Button icon="excel-attachment" design="Attention" disabled={exporting} onClick={exportCsv}>
          {exporting ? "Exportiere…" : "CSV-Export"}
        </Button>
      </div>

      {data === null ? (
        <div className="center-screen"><BusyIndicator active /></div>
      ) : data.bookings.length === 0 ? (
        <p className="muted">Keine Buchungen gefunden.</p>
      ) : (
        <>
          <p className="muted">{data.total} Buchung(en)</p>
          <div className="table-scroll">
          <table className="data-table">
            <thead>
              <tr><th>Termin</th><th>Kunde</th><th>E-Mail</th><th>Status</th><th>Link</th><th>Meet</th><th></th></tr>
            </thead>
            <tbody>
              {data.bookings.map((b) => (
                <tr key={b.id}>
                  <td>{b.appointment}</td>
                  <td>{b.customerName || <em className="muted">gelöscht</em>}</td>
                  <td>{b.customerEmail || <em className="muted">gelöscht</em>}</td>
                  <td><span className={`badge ${b.status}`}>{b.statusLabel}</span></td>
                  <td>{b.linkLabel || "—"}</td>
                  <td>{b.meetUrl ? <a href={b.meetUrl} target="_blank" rel="noreferrer">Meet</a> : "—"}</td>
                  <td style={{ textAlign: "right" }}>
                    {b.status !== "cancelled" && <Button design="Transparent" icon="decline" onClick={() => cancel(b)}>Stornieren</Button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </>
      )}
    </div>
  );
}
